import { createElement } from 'react';
import './index.scss';
const OadpImg = function OadpImg({ src, className, alt, ...otherProps }) {
    return (createElement("img", { src: src, className: className, alt: alt }));
};
export default OadpImg;
